import { Modal } from 'react-bootstrap'
import Addmeeting from './Addmeeting'

const Editmeeting = ({isrescheduled,defaultattendee,meetingInfo, meetingid, hide, show,getMeetingListData,GetMeetingDetails ,iscategory}) => {
  return (
    <Modal
    className='ismodalmeeting'
      show={show}
      onHide={hide}
      size='xl'
      centered
      style={{backdropFilter:"blur(6px)"}}
    >
      <Modal.Body className="p-0">
        <Addmeeting isrescheduled={isrescheduled} defaultattendee={defaultattendee} iscategory={iscategory} meetingInfo={meetingInfo} meetingid={meetingid} hide={hide} getMeetingListData={getMeetingListData} GetMeetingDetails={GetMeetingDetails}/>
      </Modal.Body>
    </Modal>
  )
}

export default Editmeeting